@let blok = block();

<!-- main row -->
@if (blok.mainRow?.length) {
    @for (mainRow of blok.mainRow; track mainRow._uid) {
        <td app-tariff-table-row
             [block]="mainRow"
             [columns]="columns()"
             [style.grid-template-columns]="columnsStyle()"
             [columnsStyle]="columnsStyle()"
             [titleColumnStartStyle]="titleColumnStartStyle()"
             [children]="blok.rows">
        </td>
    }
}
